import { ApiServiceV2, CMSStoryblokServiceV2 } from '@sunrise-upc/ajax-lib';
import { v4 as generateUID } from 'uuid';
import { APIResourceConstants } from '../api-constants';
import { LineTableBasicPropConfig } from '..';

class storyBlokServices {
  apiServiceInstance: ApiServiceV2;
  constructor() {
    this.apiServiceInstance = ApiServiceV2?.getApiServiceInstance();
  }
  getStoryBlokData = (lang = 'en', prodName: any, accessoryPath: string) => {
    const filterQuery = `filter_query[productId][in]=${prodName}&filter_query[component][in]=deviceProductBase`;
    const parameter = {
      type: 'B2C',
      starts_with: accessoryPath,
      per_page: 10,
      filterQueryParam: filterQuery,
      language: lang
    };
    const options = this.apiServiceInstance?.getOption();
    options.headers = {
      ...options?.headers,
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants?.X_SUN_CHAL,
    };
    options.params = {};
    const sbUrl = LineTableBasicPropConfig?.getInstance()?.getSBUrl();
    const url = `${sbUrl}${APIResourceConstants.STORIES}`;

    return CMSStoryblokServiceV2
      .get(url, parameter)
      .then((response: any) => {
        return { sbStory: response };
      })
      .catch((err) => {
        throw err;
      })
  };
}
const storyBlokService: storyBlokServices = new storyBlokServices();
export default storyBlokService;